import * as Sentry from '@sentry/react';

declare const __PULSER_STUDIO_VERSION__: string;

export const init = (): void => {
  const dsn = import.meta.env.SENTRY_DSN;
  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    release: __PULSER_STUDIO_VERSION__,
    environment: import.meta.env.ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    sendDefaultPii: true,
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1
  });
};
